function emitWebflowFirstLoad() {
  if (!window.Webflow?.require) return;

  const webflowInteractions = window.Webflow.require("ix3");

  if (typeof webflowInteractions?.emit === "function") {
    webflowInteractions.emit("first-load");
  }
}

if (document.documentElement.classList.contains("w-mod-ix3")) {
  emitWebflowFirstLoad();
} else {
  window.addEventListener("__wf_ix3_ready", emitWebflowFirstLoad, { once: true });
}

if (window.ScrollTrigger) {
  window.ScrollTrigger.config({
    ignoreMobileResize: true,
  });
}

const footerYear = document.getElementById("footerYear");

if (footerYear) {
  footerYear.textContent = new Date().getFullYear();
}

if (window.jQuery) {
  const $ = window.jQuery;

  if ($('[data-control="button__modal-form--trigger"]').length) {
    $(document).on("click", '[data-control="button__modal-form--trigger"]', function () {
      // The video variant is handled by features/video-modal.js
      if (this.getAttribute("data-wf--modal-trigger--variant") === "video") return;

      $(".section__modal").addClass("is-open");
    });

    $(document).on("click", ".modal__close", function (event) {
      event.preventDefault();
      event.stopPropagation();
      $(this).closest(".section__modal").removeClass("is-open");
    });

    $(document).on("keydown", (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        $(".section__modal.is-open").removeClass("is-open");
      }
    });
  }
}
